import {
  TaskRecord,
  TaskType,
  TaskStatus,
} from '~/modules/transportation/types';
import { createQueryHook } from '~/shared/providers/api';
import {
  maybeParseZonedDateTime,
  parseZonedDateTime,
} from '~/shared/utils/dateTime';

interface GetRouteTasksVariables {
  routeId: string;
}

export const useRouteTasksQuery = createQueryHook(
  'transportation.routeTasks',
  (variables: GetRouteTasksVariables) => ({
    tasks: {
      __args: {
        filter: {
          routeIds: [variables.routeId],
        },
        sorting: ['RoutePositionAsc'],
      },
      page: {
        total: true,
      },
      entries: {
        id: true,
        type: true,
        status: true,
        fulfillmentServiceId: true,
        sourceServiceId: true,
        accountId: true,
        accountAddressId: true,
        facilityId: true,
        routeId: true,
        routePosition: true,
        assetId: true,
        assetTypeId: true,
        assetGroup: true,
        startedAt: true,
        completedAt: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data): { tasks: TaskRecord[] } => ({
      tasks: (data?.tasks?.entries ?? []).map((task) => ({
        id: task.id,
        type: task.type as TaskType,
        status: task.status as TaskStatus,
        fulfillmentServiceId: task.fulfillmentServiceId,
        sourceServiceId: task.sourceServiceId ?? undefined,
        accountId: task.accountId ?? undefined,
        accountAddressId: task.accountAddressId ?? undefined,
        facilityId: task.facilityId ?? undefined,
        routeId: task.routeId ?? undefined,
        routePosition: task.routePosition ?? undefined,
        assetId: task.assetId ?? undefined,
        assetTypeId: task.assetTypeId ?? undefined,
        assetGroup: task.assetGroup ?? undefined,
        startedAt: maybeParseZonedDateTime(task.startedAt),
        completedAt: maybeParseZonedDateTime(task.completedAt),
        timestamps: {
          createdAt: parseZonedDateTime(task.timestamps.createdAt),
          updatedAt: parseZonedDateTime(task.timestamps.updatedAt),
        },
      })),
    }),
  },
);
